module.exports = __webpack_public_path__ + "img/cxTrends-5.8397b32d.png";